export default {
    getSavers: state => state.savers,
}